// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/registry.npmmirror.com+css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user_list_page .list_button[data-v-101e81a2] {\n  width: 80px;\n  height: 30px;\n  line-height: 30px;\n  text-align: center;\n  border: none;\n  color: #fff;\n  font-size: 12px;\n  border-radius: 5px;\n  margin-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
